/**
 * 从部门 ID/路径解析主体（collection）。
 * 部门路径格式如 10000001-10000002-10000003，主体为第一段 10000001。
 */
export function getCollectionFromDeptId(deptId: string | undefined): string | undefined {
  if (!deptId || !deptId.trim()) return undefined
  const trimmed = deptId.trim()
  const first = trimmed.indexOf('-') >= 0 ? trimmed.split('-')[0] : trimmed
  return first || undefined
}
